Quiz.wcag = {
	props: ['refTarget'],

	data : function() {
		return {
			visible: false,
		};
	},

	mounted: function() {
	},

	unmounted: function() {
		Tab.clearGroup("quest.wcag");
	},

	methods: {
		toggle: function() {
			this.visible = !this.visible;
			Tab.clearGroup("quest.wcag");

			if (this.visible) {
				setTimeout(function() {
					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .c0"));
					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .c1"));
					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .c2"));
					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .c3"));

					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .f1"));
					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .f2"));
					Menu.addBasicTab("quest.wcag", $("#quiz #wcagpanel .f3"));
				}, 100);
			}
		},

		buildCss: function() {
			if (Quiz.wcagStyleOverride != undefined) {
				document.head.removeChild(Quiz.wcagStyleOverride);
			}

			Quiz.wcagStyleOverride = document.createElement('style');

			Quiz.wcagStyleOverride.textContent = '
			  ' + this.refTarget + ' {
			    ' + this.contrastStyle + '
			    ' + this.sizeStyle + '
			  }			  
			';

			document.head.appendChild(Quiz.wcagStyleOverride);
		},

		contrast: function(v) {
		
			this.contrastStyle = '';
			if (this.sizeStyle == undefined) this.sizeStyle = '';	
		
			switch(v) {
				case 0: 
				break;
				case 1:
					this.contrastStyle = 'background-color: #000000 !important; color: #fff !important;';
				break;
				case 2:
					this.contrastStyle = 'background-color: #ff0 !important; color: #000 !important;';
				break;
				case 3: 
					this.contrastStyle = 'background-color: #000000 !important; color: #ff0 !important;';
				break;
			};

			this.buildCss();

			this.$emit('change', {'contrast': v});
		},

		size: function(v) {
			this.sizeStyle = '';	
			if (this.contrastStyle == undefined) this.contrastStyle = '';

			switch(v) {
				case 0: 
				break;
				case 1:
					this.sizeStyle = 'font-size: 20px !important;line-height: 30px !important;';
				break;
				case 2:
					this.sizeStyle = 'font-size: 32px !important;line-height: 42px !important;';
				break;
			};

			this.buildCss();

			this.$emit('change', {'size': v});
		}
	},

	template: '
	<div style="display:flex; gap:8px; align-items:start">
		<div class="wcag">
			<a href="javascript:void(null);" v-on:click="toggle()" title="Ustawienia dostępności" id="wcagicon" :class="{speaks: true, wcagiconopen: visible}" data-speakgroup="TIPS" data-speak="HTML5.info.wcagbutton">A</a>
		</div>

		<div id="wcagpanel" :class="{wcagopen:visible}" style="overflow:visible;position: initial; padding:0px;line-height:normal;">
			<div class="contrast" style="">
				<a href="javascript:void(null);" v-on:click="contrast(0)" title="normalny kontrast" class="ctr c0 speaks" data-speakgroup="TIPS" data-speak="HTML5.info.wcag.contrast_normal">A</a>
				<a href="javascript:void(null);" v-on:click="contrast(1)" title="biały tekst na czarnym tle" class="ctr c1 speaks" data-speakgroup="TIPS" data-speak="HTML5.info.wcag.white_on_black">A</a>
				<a href="javascript:void(null);" v-on:click="contrast(2)" title="czarny tekst na żółtym tle" class="ctr c2 speaks" data-speakgroup="TIPS" data-speak="HTML5.info.wcag.black_on_yellow">A</a>
				<a href="javascript:void(null);" v-on:click="contrast(3)" title="żółty tekst na czarnym tle" class="ctr c3 speaks" data-speakgroup="TIPS" data-speak="HTML5.info.wcag.yellow_on_black">A</a>
			</div>
			<div class="brk">
			</div>
			<div class="sizes" style="margin-top:-2px">
				<a href="javascript:void(null);" class="sz f1 speaks" v-on:click="size(0)" data-speakgroup="TIPS" data-speak="HTML5.info.wcag.font_normal" title="normalna czcionka">A</a>
				<a href="javascript:void(null);" class="sz f2 speaks" v-on:click="size(1)" data-speak="HTML5.info.wcag.font_bigger" title="powiększona czcionka" data-speakgroup="TIPS">A<sup>+</sup></a>
				<a href="javascript:void(null);" class="sz f3 speaks" v-on:click="size(2)" data-speak="HTML5.info.wcag.font_verybig" title="bardzo powiększona czcionka" data-speakgroup="TIPS">A<sup>++</sup></a>
			</div>
		</div>
	</div>'
};

Quiz.pqWin =  {

	data : function() {
		return {
			visible: false,
			quest: {},
			mediaPath: '',
			state: 'playing',
			points: 0,
			shuffled: [],
			wrongLeft: null,
			wrongRight: null,
			selectedLeft:null,
			selectedRight:null,
			paired:{},
			showResult: false,
			rewardedPoints: 0,
			rewards: {},
			rewardsCount: 0,
			totalQuests: 0,
			forceDiploma: false,
			results: {},
			loot: {},
			collected: false,
			progress: [],
			speaking: false,
			winspeaking: false,
			showFullImage: false,
			showFullWinImage: false,
			showFullVideo: false,
			showScoreBoard: false,
			cms: false,
			finishingQuestId: 0,
			totalOnPanorama: 0,
			answeredOnPanorama: 0,
			puzzles: [],
			pw:100,
			ph:100,
			pgrid:4,
			markedPuzzle: null,
			puzzleMode: 'any',
			windowstyle: {},
			panelstyle: {},
			winstyle: {},
		};
	},

	mounted: function() {
	},

	methods: {
		arrangeTabs: function(type) {
			setTimeout(function() {
				switch(type) {
					case 'won-lose':
						Tab.clearGroup("quest.quiz");
						Tab.clearGroup("quest.wcagicon");
						Menu.addBasicTab("quest.wcagicon", $("#quiz .window #wcagicon"));
						Menu.addBasicTab("quest.quiz", $("#quiz .window .close"));
						Menu.addBasicTab("quest.quiz", $("#quiz .window .close-button"));
					break;
					default:
						Tab.clearGroup("quest.quiz");
						Tab.clearGroup("quest.wcagicon");
						Menu.addBasicTab("quest.wcagicon", $("#quiz .window #wcagicon"));
						Menu.addBasicTab("quest.quiz", $("#quiz .window .close"));
						$("#quiz .window .answer").each(function (idx, item) {
							Menu.addBasicTab("quest.quiz", $(item));
						});
				}
			}.bind(this), 100);
		},

		shuffleArray: function(array) {
			for (var i = array.length - 1; i >= 0; i--) {
				var j = Math.floor(Math.random() * (i + 1));
				var temp = array[i];
				array[i] = array[j];
				array[j] = temp;
			}
			return array;
		},

		selectOne: function(idx) {
			if (this.selectedLeft == null || this.selectedRight != null) {
				this.selectedLeft = idx;
				this.selectedRight = null;
			}
			else if (this.selectedRight == null) {
				this.selectedRight = idx;

				setTimeout(function() {
					var tmp = this.shuffled[this.selectedLeft];
					this.shuffled[this.selectedLeft] = this.shuffled[this.selectedRight];
					this.shuffled[this.selectedRight] = tmp;
					this.selectedLeft = null;
					this.selectedRight = null;

					this.showResult = true;
					console.log(this.shuffled);
					for(var e in this.shuffled) {
						if (this.shuffled[e] != e) this.showResult = false;
					}
				}.bind(this), 500);
			}
		},

		open: function (quest_id, spot) {
			this.$refs.assetOpen.play();
			this.spot = spot;
			this.collected = false;
			$('.window').removeClass('wide');
			this.showResult = false;
			this.cms = player.cms;

			$.getJSON("/html5/placequestloader.php?id=" + quest_id).then(function (response) {
				this.quest = response.quest;
				this.mediaPath = response.media_path;
				this.quest.data = JSON.parse(response.quest.data);
				this.visible = true;
				this.state = 'playing';

				this.panelstyle = {
					'background-image': 'url(' + this.mediaPath + '/skins/gamebg.jpg)'
				};

				this.winstyle = {
					'min-height': '500px',
					'background-image': 'url(' + this.mediaPath + '/skins/winbg.jpg)'
				}

				this.collected = true;
				for(idx in this.quest.data.required) {
					if (this.loot[this.quest.data.required[idx].symbol] == undefined) {
						this.collected = false;
					}
				}

				if (this.quest.data.pairs != undefined) {
					this.shuffled = [];
					setTimeout(function() {$('.window').addClass('wide');}, 200);
					for(var idx in this.quest.data.pairs) {
						this.shuffled.push(idx);
					}
					this.shuffled = this.shuffleArray(this.shuffled);
					setTimeout(function() {this.showResult = this.checkPairs();}.bind(this), 200);
				}

				if (this.quest.type == 'find.item.go') {
					setTimeout(function() {$('.window').addClass('wide');}, 200);
				}

				if (this.quest.type == 'find.item.puzzle') {
					this.puzzles = [];
					this.sourceimage = new Image();
					this.sourceimage.src = this.mediaPath + '/assets/images/' + this.quest.image;

					setTimeout(function() {
						$('.window').addClass('wide');
						var idx = 0;
						this.shuffled = [];
						for(idx = 0; idx < this.pgrid * this.pgrid; idx ++) this.shuffled.push(idx);
						idx = 0;
						this.shuffled = this.shuffleArray(this.shuffled);
						this.pw = Math.floor(500 / this.pgrid);
						this.ph = this.pw;

						if (this.puzzleMode == 'swapempty') {
							this.hidden = Math.floor(Math.random() * (this.pgrid * this.pgrid - 0.01));
						} else this.hidden = -1;

						for(var y = 0; y < this.pgrid; y ++) {
							for(var x = 0; x < this.pgrid; x ++) {
								var left = x * this.pw;
								var top = y * this.ph;
								var p = {style: {'width': this.pw + 'px', 'height': this.ph + 'px', 'position': 'absolute', 'left': left + 'px', 'top': top + 'px', 'border':'1px solid #ffffff', 'box-sizing': 'border-box', 'opacity': this.hidden == idx?'0.3':'1'}, 'hidden': this.hidden == idx, 'id': 'p' + idx, 'idx': idx, 'shuffled': this.shuffled[idx], 'overlay': {'position': 'absolute', 'width': '100%', 'height': '100%', 'z-index': 1, 'top': '0px'}, 'sliding': false};
								this.puzzles.push(p);
								idx ++;
							}
						}
						setTimeout(function() {
							var imgwidth = Math.round(this.sourceimage.width / this.pgrid);
							var imgheight = Math.round(this.sourceimage.height / this.pgrid);

							for(var idx in this.puzzles) {
								var puzzle = this.puzzles[idx];
								var left = (puzzle.shuffled % this.pgrid) * imgwidth;
								var top = Math.floor(puzzle.shuffled / this.pgrid) * imgheight;
								var canvas = document.querySelector('#' + puzzle.id);
								var context = canvas.getContext('2d');
								context.drawImage(this.sourceimage, left, top, imgwidth, imgheight, 0, 0, this.pw, this.ph);
							}
						}.bind(this), 200);
					}.bind(this), 500);
				}

				if (this.quest.data.sequence != undefined) {
					this.shuffled = [];
					setTimeout(function() {$('.window').addClass('wide');}, 200);
					for(var idx in this.quest.data.sequence) {
						this.shuffled.push(idx);
					}
					this.shuffled = this.shuffleArray(this.shuffled);
				}

				this.arrangeTabs();

			}.bind(this));

			$.getJSON("/html5/placequestloader.php?score=1&place_id=" + player.ident).then(function (response) {
				this.totalQuests = response.quests.length;

				this.totalOnPanorama = 0;
				this.answeredOnPanorama = 0;
				for(var i in response.quests) {
					if (parseInt(response.quests[i].place_id) == player.ident) {
						this.totalOnPanorama ++;
						if (response.quests[i].type == 'find.item.collect') this.finishingQuestId = response.quests[i].id;
						if (parseInt(response.quests[i].place_id) == player.ident)
							this.answeredOnPanorama += isNaN(parseFloat(this.rewards[response.quests[i].id])) ? 0 : 1;
					}
				}

			}.bind(this));
		},

		answerQuest: function (idx) {
			if (this.quest.data.correct == idx) {
				this.won();
			} else {
				this.lose();
			}
		},

		answerNo: function () {
			if (this.quest.data.correct == 'N') {
				this.won();
			} else {
				this.lose();
			}
		},

		answerYes: function () {
			if (this.quest.data.correct == 'Y') {
				this.won();
			} else {
				this.lose();
			}
		},

		checkPairs: function() {
			var total = 0;
			for(var p in this.paired) {
				total ++;
			}

			return this.quest.data.pairs.length == total;
		},

		selectLeft: function(idx) {
			this.selectedLeft = idx;

			if (this.selectedRight != null) {
				if (this.selectedLeft == this.selectedRight) {
					this.paired['p' + this.selectedLeft] = 1;
					this.$refs.correct.play();
				} else {
					this.$refs.incorrect.play();
					this.wrongLeft = this.selectedLeft;
					this.wrongRight = this.selectedRight;
					setTimeout(function() {
						this.wrongLeft = null;
						this.wrongRight = null;
					}.bind(this), 500);
				}

				this.selectedLeft = null;
				this.selectedRight = null;

				if (this.checkPairs()) this.showResult = true;
			}
		},

		selectRight: function(idx) {
			this.selectedRight = this.shuffled[idx];
			
			if (this.selectedLeft != null) {
				if (this.selectedLeft == this.selectedRight) {
					this.paired['p' + this.selectedLeft] = 1;
					this.$refs.correct.play();
				} else {
					this.$refs.incorrect.play();
					this.wrongLeft = this.selectedLeft;
					this.wrongRight = this.selectedRight;
					setTimeout(function() {
						this.wrongLeft = null;
						this.wrongRight = null;
					}.bind(this), 500);
				}

				this.selectedLeft = null;
				this.selectedRight = null;

				if (this.checkPairs()) this.showResult = true;
			}
		},

		movePuzzle: function(puzzle) {
			var x = puzzle.idx % this.pgrid;
			var y = Math.floor(puzzle.idx / this.pgrid);
			var empty = null;

			if (this.puzzleMode == 'swapempty') {
				if (x > 0 && this.puzzles[x - 1 + y * this.pgrid].hidden) {
					empty = x - 1 + y * this.pgrid;
				}
				if (x < this.pgrid - 1 && this.puzzles[x + 1 + y * this.pgrid].hidden) {
					empty = x + 1 + y * this.pgrid;
				}
				if (y < this.pgrid - 1 && this.puzzles[x + (y + 1) * this.pgrid].hidden) {
					empty = x + (y + 1) * this.pgrid;
				}
				if (y > 0 && this.puzzles[x + (y - 1) * this.pgrid].hidden) {
					empty = x + (y - 1) * this.pgrid;
				}
			} else {
				if (this.markedPuzzle == null) {
					//puzzle.style['box-shadow'] = 'inset 0px 0px 51px 34px rgba(255, 255, 255, 1);';
					this.$set(this.puzzles[puzzle.idx].overlay, 'box-shadow', 'inset 0px 0px 51px -11px rgba(255, 255, 255, 1)');
					this.markedPuzzle = puzzle;
					return;
				} else if (this.markedPuzzle == puzzle) {
					puzzle.overlay['box-shadow'] = '';
					this.markedPuzzle = null;
					return;
				}

				empty = this.markedPuzzle.idx;
				this.markedPuzzle.overlay['box-shadow'] = '';

				this.markedPuzzle = null;
			}

			//console.log(x + ', ' + y);
			//if (x - 1 >= 0) console.log(x + ' - 1, ' + y + ' = ' + this.puzzles[x - 1 + y * 5].hidden);
			//if (x + 1 <= 4) console.log(x + ' + 1, ' + y + ' = ' + this.puzzles[x + 1 + y * 5].hidden);
			//if (y + 1 <= 4) console.log(x + ', ' + y + ' + 1 = ' + this.puzzles[x + (y + 1) * 5].hidden);
			//if (y - 1 >= 0) console.log(x + ', ' + y + ' - 1 = ' + this.puzzles[x + (y - 1) * 5].hidden);

			if (empty != null) {
				this.$refs.puzzleswap.play();

				this.puzzles[empty].sliding = true;
				this.puzzles[puzzle.idx].sliding = true;

				empty = this.puzzles[empty];

				var tmpl = puzzle.style.left;
				var tmpt = puzzle.style.top;
				this.puzzles[puzzle.idx].style.left = empty.style.left;
				this.puzzles[puzzle.idx].style.top = empty.style.top;
				this.puzzles[empty.idx].style.left = tmpl;
				this.puzzles[empty.idx].style.top = tmpt;

				var pidx = puzzle.idx;
				var eidx = empty.idx;

				setTimeout(function() {
					this.puzzles[pidx].sliding = false;
					this.puzzles[eidx].sliding = false;
				}.bind(this), 1000);

				var tmp = this.puzzles[pidx];
				this.puzzles[pidx] = this.puzzles[eidx];
				this.puzzles[eidx] = tmp;

				this.puzzles[pidx].idx = pidx;
				this.puzzles[eidx].idx = eidx;

				for(var idx in this.puzzles) {
					if (this.puzzles[idx].idx !=this.puzzles[idx].shuffled) return;
				}

				this.$refs.puzzlewin.play();

				this.arranged = true;
				for(var idx in this.puzzles) {
					this.puzzles[idx].style.border = '';
				}
			}
		},

		won: function () {
			this.$refs.correct.play();
			var points = this.points;
			if (this.results[this.quest.id] == undefined) {
				this.points += parseInt(this.quest.points);
				this.rewardedPoints = parseInt(this.quest.points);
				this.rewards[this.quest.id] = this.rewardedPoints;
				this.rewardsCount ++;
				this.answeredOnPanorama ++;
			} else if (this.results[this.quest.id] < 0) {
				this.points += parseInt(this.quest.points) / 2;
				this.rewardedPoints = parseInt(this.quest.points) / 2;
				this.rewards[this.quest.id] = this.rewardedPoints;
				this.rewardsCount ++;
				this.answeredOnPanorama ++;
			} else {
				this.rewardedPoints = 0;
			}

			if (this.points > 0 && points == 0) {
				setTimeout(function () {
					Menu.addBasicTab("quest.scorewidget", $("#myscore"));
				}, 100);
			}

			QuestManager.looted[this.quest.id] = true;

			var idx;

			if (this.quest.data.items && this.quest.data.items.length > 0) {
				for(idx in this.quest.data.items) {
					var item = this.quest.data.items[idx];
					this.loot[item.tag] = item;
				}
			}

			this.state = 'won';
			this.results[this.quest.id] = 1;
			if (this.quest.data.preserve_hotspot != '1') {
				this.spot.node.remove();
				delete this.spot;
			}

			if (this.rewardsCount >= this.totalQuests || this.quest.type == 'find.item.go') {
				this.close();
				this.scoreBoard();
			}

			this.arrangeTabs('won-lose');
		},

		lose: function () {
			this.$refs.incorrect.play();
			if (this.results[this.quest.id] == undefined) {
				this.results[this.quest.id] = -1;
			} else {
				this.results[this.quest.id]--;
			}
			this.state = 'lose';
			this.arrangeTabs('won-lose');
		},

		travel: function() {
			var idx;
			if (this.quest.data.quest_items == 'delete') {

				for(idx in this.quest.data.required) {
					var item = this.quest.data.required[idx];
					delete this.loot[item.symbol];
				}
			}

			this.answeredOnPanorama = 0;
			player.go(this.quest.data.dest.id, this.quest.data.dest.look_at);
			this.close();
		},

		toggleSpeech: function () {
			if (!this.speaking)
				this.$refs.speech.play();
			else
				this.$refs.speech.pause();
			this.speaking = !this.speaking;
		},

		toggleWinSpeech: function () {
			if (!this.winspeaking)
				this.$refs.winspeech.play();
			else
				this.$refs.winspeech.pause();
			this.winspeaking = !this.winspeaking;
		},

		showImage: function () {
			this.showFullImage = true;
		},

		showWinImage: function () {
			this.showFullWinImage = true;
		},

		showVideo: function () {
			this.showFullVideo = true;
			setTimeout(function() {
				this.media = new vplayer();
				this.media.fitScreen($('#fullvideoplayer').width(), $('#fullvideoplayer').height(), 1);

				$('#fullvideoplayer').html('');
				$('#fullvideoplayer').append(this.media.embed());

				this.media.load(this.mediaPath + '/assets/videos/' + this.quest.data.full_video);
				this.media.autostart(true, false);

				this.media.setTitle(this.quest.data.full_video);
			}.bind(this), 100);
		},

		showWinVideo: function () {
			this.showFullVideo = true;
			setTimeout(function() {
				this.media = new vplayer();
				this.media.fitScreen($('#fullvideoplayer').width(), $('#fullvideoplayer').height(), 1);

				$('#fullvideoplayer').html('');
				$('#fullvideoplayer').append(this.media.embed());

				this.media.load(this.mediaPath + '/assets/videos/' + this.quest.data.win_full_video);
				this.media.autostart(true, false);

				this.media.setTitle(this.quest.data.win_full_video);
			}.bind(this), 100);
		},

		closeFullImage: function () {
			this.showFullImage = false;
		},

		closeFullWinImage: function () {
			this.showFullWinImage = false;
		},

		closeFullVideo: function () {
			$('#fullvideoplayer').html('');
			this.showFullVideo = false;
		},

		close: function() {
			this.$refs.assetClose.play();
			this.visible = false;
			Tab.clearGroup("quest.quiz");
			Tab.clearGroup("quest.wcag");

			if (this.answeredOnPanorama >= this.totalOnPanorama - 1 && this.totalOnPanorama > 1) {
				setTimeout(function() {
					this.open(this.finishingQuestId, null);
				}.bind(this), 500);
			}
		},

		scoreBoard: function() {
			this.showScoreBoard = true;
			this.progress = [];
			$.getJSON("/html5/placequestloader.php?score=1&place_id=" + player.ident).then(function (response) {
				this.totalQuests = response.quests.length;
				for(var i in response.quests) {
					if (parseInt(response.quests[i].place_id) == player.ident)
						this.progress.push({'title': response.quests[i].title, 'points': (isNaN(parseFloat(this.rewards[response.quests[i].id])) ? 0 : parseFloat(this.rewards[response.quests[i].id]))});
				}
				this.arrangeTabs();
			}.bind(this));
		},

		closeScoreBoard: function() {
			this.showScoreBoard = false;
		},

		wcag: function(payload) {
		},
	},

	watch: {
	},

	computed: {
		diploma: function() {
			var payload = {
				points: this.points,
				rewardedPoints: this.rewardedPoints,
				rewards: this.rewards,
				rewardsCount: this.rewardsCount,
				totalQuests: this.totalQuests,
				results: this.results,
				pano_id: player.ident
			};

			return JSON.stringify(payload);
		}
	},

	template: '#tpl-pqwin'
};
